export default function Accommodation({ copy }) {
  return (
    <section id="stay" className="accommodation section-shell">
      <div className="section-heading">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2>{copy.title}</h2>
      </div>
      <div className="hotel-list">
        {copy.hotels.map((hotel, index) => (
          <article className="hotel-card" key={hotel.name}>
            <span>0{index + 1}</span>
            <h3>{hotel.name}</h3>
            <p>{hotel.detail}</p>
          </article>
        ))}
      </div>
      <p className="transport-note">{copy.note}</p>
    </section>
  );
}